import React from "react";
import { Platform, View } from "react-native";
import { Text } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";
import { LinkButton, ScreenContainer } from "../components";
import NoAccessIcon from "../svgs/NoAccessIcon";
import { NavigationProps } from "./types";

function BackLink({ navigation }: { navigation: NavigationProps }) {
  function onPress() {
    if (Platform.OS === "web") {
      return navigation.navigate("DeferredComp");
    }
    return navigation.navigate("Main");
  }
  return (
    <View className="mt-3">
      <LinkButton onPress={onPress}>Go Back</LinkButton>
    </View>
  );
}

export default function NoAccessScreen() {
  const navigation = useNavigation<NavigationProps>();
  return (
    <ScreenContainer noBorder testID="no-access-screen">
      <View className="items-center justify-center h-full max-w-3xl m-8">
        <NoAccessIcon />
        <Text className="text-title-5 text-ink-light font-700 mt-4">403 Error</Text>
        <Text className="text-regular-normal text-ink-light font-400 mt-4 text-center w-2/3">
          You do not have permission to access this page.
        </Text>
        <BackLink {...{ navigation }} />
      </View>
    </ScreenContainer>
  );
}
